import { forEach, map, uniqueId, isEmpty } from 'lodash';

import { OwnedObject } from 'gear';

import { Xml } from '../util';
import { Matrix } from '../geometry';

import { Figure } from './figure';
import { updateArray$ } from './detail/processor';

export const PowerClipContent = OwnedObject.extend({ typeName: 'PowerClipContent', __debugProps: true,

  Properties: {
    id      : { type: 'string', def: null },
    figures : { type: 'Figure[]', def: [], onChange() { this.invalidate(); } }
  },

  init( c ) {
    this._localId = uniqueId();
    this._cloneLink = null;
    this.callParent(c);
  },

  clone() {
    const clonedContent = new PowerClipContent({ id: this._id, figures: this._figures.cloneDeep() });

    // This is used by PowerClipLink clone while cloning the output figure
    // So the links points to the new content
    this._cloneLink = clonedContent;

    return clonedContent;
  },

  update$() {
    return updateArray$(this._figures);
  },

  transform( t ) {
    const figures = this._figures;
    //_.forEach(this._figures,function(f) {
    for(let k=0,kEnd=figures.length;k<kEnd;++k) {
      figures[k].transform(t);
    }//);
    return this;
  },

  unclippedFigures() {
    return map( this.figures, f => Figure._ungrouped( f.clone(), this ) );
  },

  extractFigures() {
    const figures = this._figures.clear(), owner = this.owner();
    if( owner ) {
      return map( figures, f => Figure._ungrouped( f, owner ) );
    }
    else {
      return figures;
    }
  },
  getColors( colors = [] ) {
    forEach( this.figures, figure => {
      figure.getColors(colors);
    });
    return colors;
  },
  getPens( pens = [] ) {
    forEach( this.figures, figure => {
      figure.getPens(pens);
    });
    return pens;
  },
  getBrushes( brushes = [], forUniqueZones = false ) {
    forEach( this.figures, figure => {
      figure.getBrushes(brushes,forUniqueZones);
    });
    return brushes;
  },
  lock( originator) {
    if( this._owner ) {
      this._owner.lock(originator||this);
    }
  },
  draw( context, transform, config ) {
    const figures = this._figures;
    //_.forEach(this._figures,function(f) {
    for(let k=0,kEnd=figures.length;k<kEnd;++k) {
      figures[k].draw(context,transform,config);
    }//);
  },
  add( figures ) { return this._figures.add(figures); }
});
Xml.addFromBuild(PowerClipContent,'PowerClipContent');

// [TODO] simplify
PowerClipContent.arrayFromXml = function( node ) {
  const pcNode = Xml.child(node,'PowerClipContents');
  if( pcNode ) {
    node = pcNode;
  }
  return Xml.getObjectArray(node,PowerClipContent,'PowerClipContent');
};

PowerClipContent.arrayBuildXml = function(node,v) {
  if( isEmpty(v) ) {
    return;
  }
  const pcNode = Xml.appendElement(node,'PowerClipContents');
  Xml.addObjectArray(pcNode,v);
};

Xml.Parser['PowerClipContent']   = Xml.makeObjectParser(PowerClipContent);
Xml.Parser['PowerClipContent[]'] = Xml.makeArrayObjectParser(PowerClipContent);

PowerClipContent.createForFigure = function(id,figures,owner) {
  //_.forEach(figures,function(f) {
  for(let k=0,kEnd=figures.length;k<kEnd;++k) {
    Figure._group(figures[k],owner);
  }//);
  return PowerClipContent({ id, figures });
};

// A PowerClipLink is a reference to a PowerClipContent bundle with a transform matrix
// It is used to held references in output figures to the actual powerclip content in
// in the input. This is done to avoid the need to create clones of the powerclip content
// while processing the input figure, something that can lead to poor performance specially
// for powerclip content nesteed in groups.
// The other objective with this abstraction is to avoid the need to reprocess the whole
// input figure in case something changed in one of the powerclip figures. The only thing
// that will be invalidated are the powerclips, and the parent figure can just be redraw
// after that. This is needed to achieve snappy real time edition of powerclip content.

export const PowerClipLink = OwnedObject.extend({ typeName: 'PowerClipLink',

  Properties: {
    content: { type: 'PowerClipContent', def: null, owned: false },
    matrix: { type: 'Matrix', def: new Matrix() }
  },

  transform( t ) {
    this.matrix = Matrix.m(t,this.matrix);
  },

  clone() {
    const content   = this._content,
        cloneLink = content._cloneLink;

    return new PowerClipLink({
      content: cloneLink || content,
      matrix: this._matrix.clone()
    });
  }
});



/** WEBPACK FOOTER **
 ** ./src/cdl/figure/power-clip.js
 **/